import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import LoaTransp from '../../components/leis/listar/loa';


function TranspScreen () {
    return (
        <Fragment>
            <Head titulo="Leis Orçamentárias Anuais do Município de Macuco"/>
            <Header />
            <Container>
                <LoaTransp />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TranspScreen;